module.exports = __webpack_public_path__ + "assets/img/bigcat_5_head.a4480ebd.png";